import { render, staticRenderFns } from "./UnsavedChangesDialog.vue?vue&type=template&id=0f1c8ae4"
import script from "./UnsavedChangesDialog.vue?vue&type=script&lang=ts"
export * from "./UnsavedChangesDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports